import { Box, Skeleton, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import bannerHP from "../../../../../../assets/images/HomePage/homePageImg 1.png";
import bannerMobile from "../../../../../../assets/images/HomePage/homePageImgMobile.png";
import { useConfigurations } from "../../../../../../context/ConfigurationsContext/ConfigurationsContext";
import StyledLink from "../../../../../../components/basic-styled-components/StyledLink/StyledLink";
import PrincipalPageToolBar from "../../../../components/PrincipalPageToolBar/PrincipalPageToolBar";
import useDeviceType from "../../../../../../hooks/useDeviceType";

const bannerCardButtonStyle = {
  alignItems: "center",
  backgroundColor: "#A62B6B",
  borderRadius: "42px",
  color: "#FFFFFF",
  display: "inline-flex",
  fontFamily: "Candara",
  fontSize: "16px",
  fontWeight: 700,
  justifyContent: "center",
  lineHeight: "20px",
  height: "44px",
  padding: "0 20px",
  textAlign: "center" as const,
  textDecoration: "none",
  width: "230px",
};

const PrincipalPageBanner = () => {
  const configurations = useConfigurations();
  const [isBreakdownOpen, setIsBreakdownOpen] = useState(false);
  const { isMobile, isTablet, isLargeDesktop } = useDeviceType();
  const txt = configurations.txt[configurations.currentlenguage];
  const defaultTxt = configurations.txt[0];
  const selectedFlag = configurations.flags[configurations.currentlenguage]?.toLowerCase();
  const selectedLanguage = configurations.lenguageList[configurations.currentlenguage]
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
  const languageAliases: Record<string, string> = {
    espanol: "spanish", francais: "french", deutsch: "german", portugues: "portuguese",
    italiano: "italian", nederlands: "dutch", russkiy: "russian", "日本語": "japanese",
    "한국어": "korean", "中文": "chinese",
  };
  const flagLanguages: Record<string, string> = {
    us: "english", gb: "english", es: "spanish", mx: "spanish", fr: "french", de: "german",
    pt: "portuguese", it: "italian", nl: "dutch", ru: "russian", jp: "japanese", kr: "korean", cn: "chinese",
  };
  const translations: Record<string, Record<number, string>> = {
    english: { 211: "View details", 212: "Close", 213: "Taxes amount", 215: "Service charge", 216: "Total", 214: "IVA" },
    spanish: { 211: "Ver detalles", 212: "Cerrar", 213: "Impuestos", 215: "Cargo por servicio", 216: "Total", 214: "IVA" },
    french: { 211: "Voir les détails", 212: "Fermer", 213: "Montant des taxes", 215: "Frais de service", 216: "Total", 214: "TVA" },
    german: { 211: "Details ansehen", 212: "Schließen", 213: "Steuerbetrag", 215: "Servicegebühr", 216: "Gesamt", 214: "MwSt." },
    portuguese: { 211: "Ver detalhes", 212: "Fechar", 213: "Valor dos impostos", 215: "Taxa de serviço", 216: "Total", 214: "VAT" },
    italian: { 211: "Visualizza dettagli", 212: "Chiudi", 213: "Importo delle imposte", 215: "Costo del servizio", 216: "Totale", 214: "I.V.A." },
    dutch: { 211: "Details bekijken", 212: "Sluiten", 213: "Belastingbedrag", 215: "Servicekosten", 216: "Totaal", 214: "IVA" },
    russian: { 211: "Подробнее", 212: "Закрыть", 213: "Сумма налогов", 215: "Сервисный сбор", 216: "Итого", 214: "НДС" },
    japanese: { 211: "詳細を見る", 212: "閉じる", 213: "税額", 215: "サービス料", 216: "合計", 214: "バット" },
    korean: { 211: "자세히 보기", 212: "닫기", 213: "세금 금액", 215: "서비스 수수료", 216: "합계", 214: "큰 통" },
    chinese: { 211: "查看详情", 212: "关闭", 213: "税额", 215: "服务费", 216: "总计", 214: "加值稅" },
  };
  const languageTranslation = translations[languageAliases[selectedLanguage || ""] || selectedLanguage || ""]
    || translations[flagLanguages[selectedFlag || ""]];
  const displayText = (id: number, existingId?: number) =>
    txt?.[id] || (existingId ? txt?.[existingId] : undefined) || languageTranslation?.[id] || defaultTxt?.[id] || "";
  const total = Number(configurations.price?.mxn || 0);
  const serviceChargeTotal = Number(configurations.servicecharge || 0);
  const serviceCharge = serviceChargeTotal / 1.16;
  const iva = serviceChargeTotal - serviceCharge;
  const taxes = total - serviceChargeTotal;

  return (
    <Box
      className="bannerprincipal"
      sx={{
        color: "#FFF",
        minHeight: "auto",
        overflow: "hidden",
        position: "relative",
        backgroundColor: "#FFF",
      }}
    >
      <Box
        component="img"
        src={isMobile ? bannerMobile : bannerHP}
        alt=""
        aria-hidden="true"
        loading="eager"
        decoding="async"
        fetchPriority="high"
        sx={{
          height: "100%",
          inset: 0,
          objectFit: isTablet || isLargeDesktop ? "cover" : "contain",
          objectPosition: isLargeDesktop ? "center center" : "center -5px",
          position: "absolute",
          width: "100%",
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          left: 0,
          right: 0,
          top: 0,
          height: "70.56%",
          pointerEvents: "none",
          position: "absolute",
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          backgroundImage:
            "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 14.111%, rgba(0, 175, 208, 0) 100%)",
          inset: 0,
          pointerEvents: "none",
          position: "absolute",
          zIndex: 0,
        }}
      />

      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PrincipalPageToolBar />

        <Box className="bannerInf">
          <Box className="bannertext">
            <Box className="bannerinfw">
              <p className="infctn">
                {txt[123]}
                <span className="infBold">
                  {" "}
                  {txt[124]}
                </span>{" "}
                {txt[125]}
                <span className="infBold">
                  {" "}
                  {txt[126]}.
                </span>
              </p>
              <p className="infctnsub">
                {txt[127]}
                <span className="infBold">
                  {" "}
                  {txt[128]}.
                </span>
              </p>
            </Box>
          </Box>

          <Box className="cardBanner">
            <Box className="cardCtn">
              {configurations.price && configurations.price.mxn > 0 ? (
                <Box className="cardContentLeft">
                  <p className="carddetails">
                    <span className="cardprice">
                      {"$" + configurations.price.mxn + " MXN"}
                    </span>{" "}
                    <span className="cardeq">
                      {txt[192]} <br/>
                    </span>{" "}
                    <span className="cardusd">
                      {"USD " + (configurations.price.usd || "-")}
                    </span>{" "}
                    <span className="cardeq">
                      {txt[162]}
                    </span>
                    <button
                      className="cardDetailsLink"
                      type="button"
                      onClick={() => setIsBreakdownOpen(true)}
                    >
                      {displayText(211)}
                    </button>
                  </p>
                </Box>
              ) : (
                <Box className="cardContentLeft">
                  <Skeleton variant="text" className="cardSkeletonTitle" />
                  <Skeleton variant="text" className="cardSkeletonDetails" />
                </Box>
              )}

              <Box className="cardActions">
                <StyledLink style={bannerCardButtonStyle} to="/Payment" variant="cardbtn">
                  {txt[131]}
                </StyledLink>
                <p className="cardOr">
                  {txt[163]}
                </p>
                <StyledLink style={bannerCardButtonStyle} to="/RecoverReceipt" variant="cardbtn">
                  {txt[164]}
                </StyledLink>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Dialog open={isBreakdownOpen} onClose={() => setIsBreakdownOpen(false)} maxWidth="xs" fullWidth>
        <DialogContent sx={{ position: "relative", pt: "32px !important" }}>
          <IconButton
            aria-label={displayText(212)}
            onClick={() => setIsBreakdownOpen(false)}
            sx={{ position: "absolute", right: 4, top: 4 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography>{displayText(213, 64)}: <strong>${taxes.toFixed(2)} MXN</strong></Typography>
          <Typography>{displayText(215, 65)}: <strong>${serviceCharge.toFixed(2)} MXN</strong></Typography>
          <Typography>{displayText(214)}: <strong>${iva.toFixed(2)} MXN</strong></Typography>
          <Typography>{displayText(216, 59)}: <strong>${total.toFixed(2)} MXN</strong></Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default PrincipalPageBanner;
